import React from 'react';
import { FormikProps, getIn } from 'formik';
import DayPickerRaw from '~/components/common/DayPicker';

interface DayPickerProps {
  disabled?: boolean;
  field: {
    name: string;
    value: any;
  };
  form: FormikProps<any>;
  clearable?: boolean;
  error?: string;
  helperText?: string | boolean;
  inputProps?: Record<string, any>;
  onChange?: (value: any) => void;
  [key: string]: any;
}

const DayPicker: React.FC<DayPickerProps> = ({
  disabled = false,
  field,
  form,
  clearable = false,
  error = '',
  helperText = '',
  inputProps = {},
  onChange,
  ...props
}) => (
  <DayPickerRaw
    {...field}
    {...props}
    disabled={disabled || !!form.values.__readOnly}
    value={field.value || ''}
    onChange={(v: any) => {
      form.setFieldValue(field.name, v);
      onChange?.(v);
    }}
    onClear={clearable ? () => form.setFieldValue(field.name, '') : null}
    inputProps={{
      name: field.name,
      error:
        !!error ||
        (!!getIn(form.touched, field.name) && !!getIn(form.errors, field.name)),
      helperText:
        helperText ||
        (getIn(form.touched, field.name) && getIn(form.errors, field.name)),
      ...inputProps,
    }}
  />
);

export default DayPicker;
